function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 309.75 354",
    style: {
      enableBackground: "new 0 0 309.75 354"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M229.69,91.5H80.06c-5.91,0-10.69-4.78-10.69-10.69c0-5.9,4.78-10.69,10.69-10.69h149.63 c5.91,0,10.69,4.79,10.69,10.69C240.38,86.72,235.6,91.5,229.69,91.5z M229.69,155.39H80.06c-5.91,0-10.69-4.8-10.69-10.69 c0-5.91,4.78-10.69,10.69-10.69h149.63c5.91,0,10.69,4.78,10.69,10.69C240.38,150.59,235.6,155.39,229.69,155.39z M229.69,219.75 H80.06c-5.91,0-10.69-4.78-10.69-10.69s4.78-10.69,10.69-10.69h149.63c5.91,0,10.69,4.78,10.69,10.69S235.6,219.75,229.69,219.75z  M261.75,6H48C24.39,6,5.25,25.14,5.25,48.75V348H25.2l44.17-32.06L112.13,348l42.75-32.06L197.63,348l42.75-32.06L284.56,348h19.94 V48.75C304.5,25.14,285.36,6,261.75,6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacture);
export default __webpack_public_path__ + "static/media/facture.da0d0eb5d492fbe5d2a9dfc37eea66fd.svg";
export { ForwardRef as ReactComponent };